module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Bank Soal")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/items',
        query: {
          mapel: _vm.$route.query.mapel
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.mapel))])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Buat Soal Baru")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.mapel))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [_c('form', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('jenjang') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('jenis') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.jenjang),
      expression: "form.jenjang"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "jenjang", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.resetGrades()
      }]
    }
  }, _vm._l((_vm.levels), function(level) {
    return _c('option', {
      key: level.id,
      domProps: {
        "value": level.id
      }
    }, [_vm._v("\n                    " + _vm._s(level.nama) + "\n                  ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('grades') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('grades') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), (_vm.form.jenjang === 3) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 10,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 10) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 10,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("10")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 11,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 11) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 11,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("11")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 12,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 12) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 12,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("12")])]) : _vm._e(), _vm._v(" "), (_vm.form.jenjang === 2) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 7,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 7) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 7,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("7")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 8,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 8) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 8,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("8")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 9,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 9) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 9,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("9")])]) : _vm._e(), _vm._v(" "), (_vm.form.jenjang === 1) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 4,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 4) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 4,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("4")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 5,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 5) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 5,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("5")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 6) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("6")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('jenis') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenis *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('jenis') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.jenis),
      expression: "form.jenis"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "jenis", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.types), function(type) {
    return _c('option', {
      key: type.id,
      domProps: {
        "value": type.id
      }
    }, [_vm._v("\n                    " + _vm._s(type.nama) + "\n                  ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('topic') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Topik *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('topic') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('app-autocomplete', {
    attrs: {
      "placeholder": "Cari Bab / (Sub) Sub Bab",
      "data": _vm.topics,
      "value": _vm.form.topic
    },
    on: {
      "selected": function($event) {
        return _vm.assignTopic($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Sumber")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.sumber),
      expression: "form.sumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.sumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "sumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.label),
      expression: "form.label"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "uppercase"
    },
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.form.label)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "label", $event.target.value)
      }, function($event) {
        _vm.labelQuery = _vm.form.label
      }]
    }
  }), _vm._v(" "), _c('app-labelAutocomplete', {
    attrs: {
      "query": _vm.labelQuery
    },
    on: {
      "selected": _vm.onLabelSelected
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Bank Soal")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_restricted),
      expression: "form.is_restricted"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.is_restricted) ? _vm._i(_vm.form.is_restricted, null) > -1 : (_vm.form.is_restricted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.is_restricted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "is_restricted", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "is_restricted", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "is_restricted", $$c)
        }
      }
    }
  }), _vm._v("\n                    Tidak dimunculkan\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Wacana")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('app-wacana', {
    attrs: {
      "value": _vm.form.wacana
    },
    on: {
      "selected": function($event) {
        _vm.form.wacana = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('soal') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Soal *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('soal') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 8,
      "value": _vm.form.soal,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.soal = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Opsi *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'has-error': _vm.errors.indexOf('opsiA') >= 0
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("A")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiA,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiA = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.indexOf('opsiA') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e()], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    class: {
      'has-error': _vm.errors.indexOf('opsiB') >= 0
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("B")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiB,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiB = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.indexOf('opsiB') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e()], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    class: {
      'has-error': _vm.errors.indexOf('opsiC') >= 0
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("C")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiC,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiC = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.indexOf('opsiC') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e()], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    class: {
      'has-error': _vm.errors.indexOf('opsiD') >= 0
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("D")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiD,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiD = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.indexOf('opsiD') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Optional:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("E")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiE,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiE = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('jawaban') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jawaban *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('jawaban') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.jawaban),
      expression: "form.jawaban"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "A",
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "jawaban", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "A"
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B"
    }
  }, [_vm._v("B")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("D")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "E"
    }
  }, [_vm._v("E")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Eigen")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.eigen),
      expression: "form.eigen"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "2.55",
      "type": "number",
      "step": "any"
    },
    domProps: {
      "value": (_vm.form.eigen)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "eigen", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pembahasan")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('app-editor', {
    attrs: {
      "rows": 8,
      "value": _vm.form.pembahasan,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.pembahasan = $event
      }
    }
  })], 1)])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-664ded1d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/itembank/Form.vue
// module id = 1358
// module chunks = 0